import { OfferUnsubscribeLoadingSpinner } from '../../offer-unsubscribe-loading-spinner/offer-unsubscribe-loading-spinner.component'

export const OfferUnsubscribeLoadingView = () => {
  return <OfferUnsubscribeLoadingSpinner />
}
